export const Dashboardconstant = {
  DASHBOARD_REVENUE_SAGA: "DASHBOARD_REVENUE_SAGA",
  DASHBOARD_REVENUE_REQUEST: "DASHBOARD_REVENUE_REQUEST",
  DASHBOARD_REVENUE_RESPONSE: "DASHBOARD_REVENUE_RESPONSE",
  DASHBOARD_REVENUE_API: "/revenue-graph",

  CUSTOMERS_SAGA: "CUSTOMERS_SAGA",
  CUSTOMERS_REQUEST: "CUSTOMERS_REQUEST",
  CUSTOMERS_RESPONSE: "CUSTOMERS_RESPONSE",
  CUSTOMERS_API: "/customer-graph",

  TIME_CONSUMED_SAGA: "TIME_CONSUMED_SAGA",
  TIME_CONSUMED_REQUEST: "TIME_CONSUMED_REQUEST",
  TIME_CONSUMED_RESPONSE: "TIME_CONSUMED_RESPONSE",
  TIME_CONSUMED_API: "/time-graph",

  POWER_CONSUMED_SAGA: "POWER_CONSUMED_SAGA",
  POWER_CONSUMED_REQUEST: "POWER_CONSUMED_REQUEST",
  POWER_CONSUMED_RESPONSE: "POWER_CONSUMED_RESPONSE",
  POWER_CONSUMED_API: "/power-graph",

  POPULAR_TIMES_SAGA: "POPULAR_TIMES_SAGA",
  POPULAR_TIMES_REQUEST: "POPULAR_TIMES_REQUEST",
  POPULAR_TIMES_RESPONSE: "POPULAR_TIMES_RESPONSE",
  POPULAR_TIMES_API: "/popular-times",
};
